export const flushAllIndexedDB = async () => {
  try {
    const dbs = await window.indexedDB.databases();

    const chatwootDbs = dbs.filter(db => db.name.startsWith('cw-store-'));

    await Promise.all(
      chatwootDbs.map(async db => {
        await window.indexedDB.deleteDatabase(db.name);
      })
    );

    await new Promise(resolve => setTimeout(resolve, 1000));

    return true;
  } catch (error) {
    return false;
  }
};
